import React from "react";
import { components } from "react-select";
import Chip from "../Chip";
import Tooltip from "../Tooltip";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  moreItemsDots: {
    padding: theme.spacing(0.5, 1)
  },
  moreItemsLabel: {
    marginLeft: "auto"
  },
  chip: {
    margin: 0
  }
}));
const MultiValue = props => {
  const {
    index,
    getValue,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const maxToShow = props.selectProps.maxChips;
  const isCompact = props.selectProps?.classNamePrefix?.includes("prmbl-autocomplete-compact");
  const overflow = getValue().slice(maxToShow).map(x => x.label);
  const MoreSelectedBadge = ({
    items
  }) => {
    const length = items.length;
    const label = `+ ${length}`;
    const labelTitle = "Open this input to see all selected values";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: labelTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.moreItemsDots,
      "aria-label": labelTitle
    }, "...")), /*#__PURE__*/React.createElement(Tooltip, {
      title: `${length} more hidden items`
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.moreItemsLabel
    }, /*#__PURE__*/React.createElement(Chip, {
      label: label,
      size: isCompact ? "small" : undefined,
      className: classes.chip
    }))));
  };
  if (otherProps.selectProps.menuIsOpen) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return index < maxToShow ? /*#__PURE__*/React.createElement(components.MultiValue, props) : index === maxToShow ? /*#__PURE__*/React.createElement(MoreSelectedBadge, {
    items: overflow
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default MultiValue;